import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import {
  API_GATEWAY_ID_CUSTOMER_SERVICE,
  API_GATEWAY_ID_PROD_SERVICE,
  INVMGMT_SERVICE_URL,
  SERVICE_URL,
} from "../utils/env.config";

/** Setup an API instance */
const prodServiceGatewayHeader = API_GATEWAY_ID_PROD_SERVICE && {
  "x-apigw-api-id": API_GATEWAY_ID_PROD_SERVICE,
};

const customerServiceGatewayHeader = API_GATEWAY_ID_CUSTOMER_SERVICE && {
  "x-apigw-api-id": API_GATEWAY_ID_CUSTOMER_SERVICE,
};

export const api = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    ...prodServiceGatewayHeader,
  },
  withCredentials: true,
});

export const api360 = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    ...customerServiceGatewayHeader,
  },
  withCredentials: true,
});

/**
 * Adds authorization headers to API calls
 * @param {AxiosRequestConfig} request
 */
const authInterceptor = async (request: AxiosRequestConfig) => {
  const accessToken = localStorage.getItem("okta-token-storage");
  if (accessToken && request.headers) {
    const token = JSON.parse(accessToken).accessToken.accessToken;

    request.headers.Authorization = `Bearer ${token}`;
  }

  return request;
};

/** Add interceptor */
api.interceptors.request.use(config => {
  if (!config.baseURL) {
    config.baseURL = INVMGMT_SERVICE_URL;
  }
  return config;
});

api360.interceptors.request.use(config => {
  if (!config.baseURL) {
    config.baseURL = SERVICE_URL;
  }
  return config;
});

/**
 * Axios response interceptors
 * @param {AxiosResponse} response
 */
const responseInterceptor = (response: AxiosResponse) => {
  return response;
};

/**
 * Axios error interceptor
 * @param {AxiosError} axiosError
 */
const errorInterceptor = (axiosError: AxiosError) => {
  if (axiosError && axiosError.response) {
    // TODO: Handle error here
    return Promise.reject(axiosError.response);
  }
  return Promise.reject(axiosError);
};

api.interceptors.request.use(authInterceptor);
api.interceptors.response.use(responseInterceptor, errorInterceptor);

api360.interceptors.request.use(authInterceptor);
api360.interceptors.response.use(responseInterceptor, errorInterceptor);
